import { io } from "socket.io-client";

const socket = io("https://staging.admin.kwicpe.com", {
  path: "/api/socket.io",
  transports: ["websocket", "polling"],
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000,
});

export default socket;